import React from 'react';

const Navbar = () => {
	return (
		<div className="navbar">
			TODO.JS
		</div>
	)
}

export default Navbar;